import { all, fork } from 'redux-saga/effects';
import {watchPreloadData, watchPreview, watchQuery} from './generator';
import {watchSubscribe} from './subscribe'
import {watchRetrieveMapRequest} from './mapDownload';

export default function* rootSaga() {
    yield all([
        fork(watchPreloadData),
        fork(watchQuery),
        fork(watchPreview),
        fork(watchSubscribe),
        fork(watchRetrieveMapRequest),
    ]);
}